import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonBookingService } from '../common-booking.service';

@Component({
  selector: 'app-garage-mapping',
  templateUrl: './garage-mapping.component.html',
  styleUrls: ['./garage-mapping.component.scss']
})
export class GarageMappingComponent extends BaseFormGroup implements OnInit {

  @Output() closeCallback = new EventEmitter();
  @Input() booking: any;
  @Output() showSuccessToastCallback = new EventEmitter();

  public garageType: string;
  public formDetails: FormGroup;
  public options = [
    {
      label: 'Start duty point',
      value: 'startDutyPoint'
    },
    {
      label: 'Pickup point',
      value: 'pickUpPoint'
    },
    {
      label: 'Select Office',
      value: 'office'
    },
    {
      label: 'Select from garage list',
      value: 'garage'
    }
  ];
  public offices: any[] = [];
  public garages: any[] = [];
  public existingGarage: any;
  public garageError: any;
  public isLoading: boolean;

  constructor(private commonBookingService: CommonBookingService, private authService: AuthService) {
    super();
   }

  ngOnInit() {
    const request = {
      bookingId: this.booking.bookingId,
      buId: this.authService.user.buId
    };
    this.commonBookingService.getBookingGarage(request).subscribe((response) => {
      this.existingGarage = response;
      for (const option of this.options) {
        if (this.existingGarage.garageType === option.value) {
          this.existingGarage.garageLabel = option.label;
          break;
        }
      }
    });
    this.commonBookingService.getGarageOptions(request).subscribe((response) => {
      this.offices = response.office || [];
      this.garages = response.garage || [];
      this.garageType = 'startDutyPoint';
      this.formDetails = new FormGroup({
        garage: new FormControl({value: '', disabled: true}, this.checkGarargeValue),
        office: new FormControl({value: '', disabled: true}, this.checkOfficeValue),
      });
    });
  }

  checkGarargeValue = (control) => {
    if (this.garageType === 'garage' && !control.value) {
      return {
        required: true
      };
    }
    return null;
  }

  checkOfficeValue = (control) => {
    if (this.garageType === 'office' && !control.value) {
      return {
        required: true
      };
    }
    return null;
  }

  onTypeChange = (value: string) => {
    if (value === this.garageType) {
      return;
    }

    if (this.garageType === 'garage') {
      this.formDetails.get('garage').disable();
      this.formDetails.get('garage').reset();
    } else if (this.garageType === 'office') {
      this.formDetails.get('office').disable();
      this.formDetails.get('office').reset();
    }

    this.garageType = value;

    if (value === 'garage') {
      this.formDetails.get('garage').enable();
    } else if (value === 'office') {
      this.formDetails.get('office').enable();
    }
  }

  cancelCallback = () => {
    this.closeCallback.emit();
  }

  getGarageLocation() {
    const selectedOfficeGuid = this.formDetails.get('garage').value;
    for (const garage of this.garages) {
      if (garage.geoCord === selectedOfficeGuid) {
        return garage;
      }
    }
  }

  getOfficeLocation() {
    const selectedOfficeGuid = this.formDetails.get('office').value;
    for (const office of this.offices) {
      if (office.guid === selectedOfficeGuid) {
        return office;
      }
    }
  }

  onSubmitClick = () => {
    if (!this.formDetails.disabled && !this.formDetails.valid) {
      this.markFormGroupDirty(this.formDetails);
      this.updateGroupValidity(this.formDetails);
    } else {
      let location;
      if (this.garageType === 'garage') {
        location = this.getGarageLocation();
      } else if (this.garageType === 'office') {
        location = this.getOfficeLocation();
      }
      const request = {
        modifierBuid: this.authService.user.buId,
        modifierGuid: this.authService.user.employeeGuid,
        bookingId: this.booking.bookingId,
        garageType: this.garageType === 'garage' ? 'vendor' : this.garageType,
        garageAddress: location && location.address,
        garageGeoCord: location && location.geoCord
      };
      this.isLoading = true;
      this.commonBookingService.updateBookingGarage(request).subscribe(() => {
        if (this.showSuccessToastCallback) {
          this.showSuccessToastCallback.emit('Garage mapping successful');
        }
        this.closeCallback.emit();
        this.isLoading = false;
      }, (response) => {
        this.garageError = response.error.message;
        this.isLoading = false;
      });
    }
  }

  hideGarageError = () => {
    this.garageError = '';
  }

  getOptionValue = (option) => {
    return option.guid || option.geoCord;
  }

  getOptionLabel = (option) => {
    return option.address;
  }


}
